import React from "react";

const DeleteIcon = ({ color = "white" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="14"
      viewBox="0 0 11 14"
      fill="none"
    >
      <path
        d="M7.16571 5.81L5.5 7.45889L3.82643 5.81L2.71857 6.90667L4.39214 8.55556L2.72643 10.2044L3.83429 11.3011L5.5 9.65222L7.16571 11.3011L8.27357 10.2044L6.60786 8.55556L8.27357 6.90667L7.16571 5.81ZM8.25 0.777778L7.46429 0H3.53571L2.75 0.777778H0V2.33333H11V0.777778H8.25ZM0.785714 12.4444C0.785714 13.3 1.49286 14 2.35714 14H8.64286C9.50714 14 10.2143 13.3 10.2143 12.4444V3.11111H0.785714V12.4444ZM2.35714 4.66667H8.64286V12.4444H2.35714V4.66667Z"
        fill={color}
      />
    </svg>

    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="17"
    //   height="16"
    //   viewBox="0 0 17 16"
    //   fill="none"
    // >
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M9.92513 2H6.5918L5.92513 2.66667H3.5918V4H12.9251V2.66667H10.5918L9.92513 2ZM10.9251 6V12.6667H5.5918V6H10.9251ZM4.25846 4.66667H12.2585V12.6667C12.2585 13.4 11.6585 14 10.9251 14H5.5918C4.85846 14 4.25846 13.4 4.25846 12.6667V4.66667Z"
    //     fill="#EDEDED"
    //   />
    // </svg>
  );
};

export default DeleteIcon;
